<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="accounting-rejected-donut-loading"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
      <card-header :title="$t('widget_rejected_expenses')"></card-header>
      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <donut-chart
              :series="series"
              :chartId="'rejectedDonut'"
              height="275"
              :center_label="$t('rejected_plural')"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import accounting from '@/http/requests/accounting'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'
export default {
  components: {
    DonutChart,
    CardHeader,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`accounting-rejected-donut-loading`)
      } else {
        this.closeLoading(`accounting-rejected-donut-loading`)
      }
    },
  },
  data() {
    return {
      series: [0],
      loading: {
        donut: false,
      },
    }
  },
  mounted() {
    this.getDonutInfo()
  },
  methods: {
    getDonutInfo() {
      this.loading.donut = true
      accounting
        .getDonutsInfo()
        .then((res) => {
          this.fillDonutTotales('rejectedDonut', res.data.rejectedCount)
          this.loading.donut = false
        })
        .catch((err) => {
          this.loading.donut = false
          console.log(err)
        })
    },
    fillDonutTotales(donutId, totalsToChart) {
      let seriesArray = []
      let labelsArray = []
      let colorsArray = []
      if (totalsToChart.length == 0) {
        seriesArray = [0]
        labelsArray = ['NO LABEL']
        colorsArray = ['#FFFFFF']
      } else {
        totalsToChart.forEach((element) => {
          seriesArray[seriesArray.length] = parseInt(element.total, 10)
          labelsArray[labelsArray.length] = element.ShortName
          colorsArray[colorsArray.length] = element.color
        })
      }
      this.series = seriesArray

      ApexCharts.exec(
        donutId,
        'updateOptions',
        {
          fill: {
            colors: colorsArray,
          },
          legend: {
            markers: {
              fillColors: colorsArray,
            },
          },
          labels: labelsArray,
          tooltip: {
            fillSeriesColor: false,
          },
        },
        false,
        true
      )
    },
  },
}
</script>